"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ItemCatalog;

var _core = require("@material-ui/core");

var _react = _interopRequireDefault(require("react"));

var _ChipStatus = require("../ChipStatus");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var useStyle = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      display: "flex",
      width: "100%",
      justifyContent: "space-between"
    },
    left: {
      fontSize: "small"
    },
    right: {
      textAlign: "right"
    }
  };
});

function ItemCatalog(_ref) {
  var id = _ref.id,
      title = _ref.title,
      geo_tags = _ref.geo_tags,
      status = _ref.status;
  var classes = useStyle(); // console.log(status)

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.left
  }, /*#__PURE__*/_react["default"].createElement("div", null, title, " ", /*#__PURE__*/_react["default"].createElement("sup", null, "[", id, "]")), /*#__PURE__*/_react["default"].createElement("div", null, geo_tags)), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.right
  }, /*#__PURE__*/_react["default"].createElement(_ChipStatus.ChipStatusCatalog, {
    code: status
  })));
}